import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";

let props = {};
let inputObj = {};
let InputJSONString = "";
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;

export const getRFQData = async (input) => {
    InputJSONString = JSON.stringify(input);
   inputObj["Activity"] = "Q_RFQ_DISPLAY";
   inputObj["Input"] = InputJSONString;
   props.input = inputObj;

const result = await GatewayGet(props, props.input);
   return result;
 }